import classNames from "classnames";
import { Swiper } from "antd-mobile";
import { useSelector } from "react-redux";
import { homeStateSelector } from "@store/redux/modules/home";
import { pxChangeVw } from "@/utils";
const WarningWeather: React.FC = () => {
  const { current } = useSelector(homeStateSelector);
  const navigate = useNavigate();
  const handleAlert = (_item: any) => {
    return () => {
      navigate("detail");
    };
  };
  return (
    !!current?.warnings?.length && (
      <WeatherMainContent className="bg-[rgba(231,231,231,0.10)] rounded-10 backdrop-sepia-[blur(10px)] h-50 overflow-hidden relative p-0">
        <div className="w-full overflow-hidden relative">
          <div className="p-0 relative">
            <div>
              {renderIconFont(
                classNames(["icon-zhixiangyouyoujiantou", "w-50 h-50 lh-55 absolute text-20 right-0 top-0 text-center"])
              )}
            </div>
            <div className="overflow-hidden relative h-50">
              <ul className="relative top-0 p-0 m-0">
                <Swiper
                  direction="vertical"
                  autoplay
                  loop
                  // @ts-ignore
                  style={{ "--height": pxChangeVw("50px") }}
                  autoplayInterval={3000}
                  indicator={() => null}
                >
                  {current.warnings.map((item: any, index: number) => {
                    const concatString =
                      item?.Description?.Localized +
                      ":" +
                      " " +
                      item?.detail?.start +
                      "-" +
                      item?.detail?.end +
                      "," +
                      item?.detail?.Summary;
                    const stringWidth = getTextWidth(concatString);
                    return (
                      <Swiper.Item key={index} onClick={handleAlert({ id: item.AlertID })}>
                        <li className="h-50 lh-50 overflow-hidden pr-10">
                          <a
                            className="color-[#fff] decoration-none block w-full h-full pr-50"
                            onClick={e => e.preventDefault()}
                            rel="noreferrer"
                          >
                            <div
                              // @ts-ignore
                              style={{ "--data-color": item?.Color?.Hex }}
                              className='float-left w-full  overflow-hidden whitespace-nowrap text-ellipsis flex items-center justify-start gap-x-8 before:content-[""] before:w-5 before:h-50 before:inline-block before:align-bottom before:bg-[var(--data-color)]'
                            >
                              <SvgIcon name="thunderstorm" color={item?.Color?.Hex} />
                              <div className="overflow-hidden w-[calc(100%-40px)]">
                                <AnimateSlide $duration={stringWidth / 3.75}>{concatString}</AnimateSlide>
                              </div>
                            </div>
                          </a>
                        </li>
                      </Swiper.Item>
                    );
                  })}
                </Swiper>
              </ul>
            </div>
          </div>
        </div>
      </WeatherMainContent>
    )
  );
};
export default WarningWeather;
